const executionFunctionByRootNodeType = ({ rootNode, localCallback, webComponentCallback }: {
  rootNode: Document | ShadowRoot,
  localCallback?: VoidFunction,
  webComponentCallback?: VoidFunction
}) => {
  if (rootNode instanceof ShadowRoot) {
    webComponentCallback?.();
  } else {
    localCallback?.();
  }
};

export default executionFunctionByRootNodeType;
